<div class="system-banner" [ngClass]="[banner.bannerType, banner.layout]">
  <div class="system-banner-inner">
    <div class="d-flex gap-2 align-items-start">
      <img
        *ngIf="!banner.hideIcon"
        class="system-banner-icon"
        [src]="banner.iconSrc || (banner.bannerType | systemBannerIcon)"
        alt="" />
      <div *ngIf="!banner.richText; else richTextBlock">{{ banner.text }}</div>
      <ng-template #richTextBlock>
        <div [innerHTML]="banner.text"></div>
      </ng-template>
    </div>

    <div *ngIf="banner.buttonText || banner.isDismissible" class="d-flex gap-2 align-items-center">
      <button
        *ngIf="banner.buttonText"
        class="no-style-button system-banner-button text-nowrap"
        (click)="textButtonClicked.emit()">
        {{ banner.buttonText }}
      </button>

      <button
        *ngIf="banner.isDismissible"
        class="no-style-button"
        aria-label="Dismiss"
        i18n-aria-label
        (click)="dismissBannerClicked.emit()">
        <img
          class="system-banner-dismiss"
          [src]="banner.dismissIconSrc || (banner.bannerType | systemBannerDismissIcon)"
          alt="" />
      </button>
    </div>
  </div>
</div>
